(function mainNav($){
    // Re-use accordion expand behavior to control state
    // between the active menu elements
    // $('#main-nav, #quick-search').UberAccordion({
    //     buttonClass: 'expand-toggle',
    //     toggle:      true,
    //     multiple:    false,
    //
    //     appliedClasses: {
    //         activeButton: 'is-active',
    //         activeTarget: 'is-active'
    //     },
    //
    //     onSelect: function($button, $target) {
    //         if ($target.hasClass('auto-height')) {
    //             $target.height($(document).height() + 'px');
    //         }
    //
    //         // Give the quick search input focus when the overlay is presented
    //         if ($target.hasClass('quick-search')) {
    //             $('#quick-search__query').focus();
    //         }
    //
    //         if ($button.hasClass('is-active')) {
    //             $('body').addClass('is-menu-expanded');
    //
    //             // Always scroll top for quick search
    //             if ($button.attr('id') === 'quick-search__toggle') {
    //                 $(window).scrollTop(0);
    //             }
    //         } else {
    //             $('body').removeClass('is-menu-expanded');
    //         }
    //     }
    // });

    $('.navbar__item .sub-nav__toggle-button').click(function() {
        var $this = $(this);
        var $parent = $this.parent();
        console.log($parent);
        $parent.toggleClass('navbar__item--current');
    });


}(jQuery));
